import { GoogleApiBaseUrls } from '@/features/googleApi/enums/GoogleApiBaseUrls';
import { AuthApiPaths } from '@/domains/auth/enums/AuthApiPaths';

export const EXCLUDED_URLS = [...Object.values(GoogleApiBaseUrls), import.meta.env.VITE_BLOB_STORAGE_URL];

export const HTTP_SERVICE_DEDUPLICATION_TTL = 300;

export const HTTP_SERVICE_CACHE_REQUESTS = new Map<string, { timestamp: number; promise: Promise<any> }>();

export const HTTP_SERVICE_UNAUTHORIZED_REQUEST_EXCEPTIONS = [AuthApiPaths.SIGN_IN, AuthApiPaths.UPDATE_PASSWORD];
